// @ts-check

/** @file Defines one catalog-owned user/project replica registry row. */

import ProjectReplicaRegistryEntryBase from "../model-bases/project-replica-registry-entry.js"
import localDatabaseModel from "../database/local-database-model.js"

/** Lightweight catalog row describing retained project storage. */
const ProjectReplicaRegistryEntryModel = localDatabaseModel(ProjectReplicaRegistryEntryBase)

export default ProjectReplicaRegistryEntryModel
